// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_ResetarAcessoPortalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /clientes/resetar-acesso-portal
 *
 * The portal's reissue-credential payload, projected onto a shape this platform
 * owns rather than passed through. Field names are English per ADR-0014 §3.
 *
 * `activation_credential` reuses Clientes_CriarAcessoPortalCredencialRow — a
 * reset always issues a fresh code (ADR-0017), so the row is the same shape as
 * on create, unlike the read-only status endpoint which never carries one.
 */
import type { Clientes_CriarAcessoPortalCredencialRow } from './Clientes_CriarAcessoPortalCredencialRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_ResetarAcessoPortalResponseDados {
cliente_id: number
document: string
portal_user_id?: string
status?: string
reissued_at?: string
activation_credential?: Clientes_CriarAcessoPortalCredencialRow
}

export type Clientes_ResetarAcessoPortalResponse = ApiResponse<Clientes_ResetarAcessoPortalResponseDados>;

registerResponseContract('Clientes_ResetarAcessoPortalResponse', {
  cliente_id:     { type: 'number',  required: true },
  document:       { type: 'string',  required: true },
  portal_user_id: { type: 'string',  required: false },
  status:         { type: 'string',  required: false },
  reissued_at:    { type: 'string',  required: false },
  activation_credential: {
    type: 'object',
    required: false,
    fields: {
      value:      { type: 'string',  required: false },
      expires_at: { type: 'string',  required: false },
      rule:       { type: 'string',  required: false },
    },
  },
})
